import type { DefaultLocaleInfo } from "@vuepress/helper";

import type { PDFLocaleData } from "../../shared/index.js";

export const pdfLocaleInfo: DefaultLocaleInfo<PDFLocaleData> = [
  [
    ["en", "en-US"],
    {
      hint: "<p>This browser does not support embedding PDFs. Please download the PDF to view it: <a href='[url]' target='_blank'>Download PDF</a></p>",
    },
  ],
  [
    ["zh", "zh-CN", "zh-Hans"],
    {
      hint: "<p>此浏览器不支持嵌入式 PDF。请下载 PDF 查看：<a href='[url]' target='_blank'>下载 PDF</a></p>",
    },
  ],
  [
    ["zh-tw", "zh-Hant"],
    {
      hint: "<p>此瀏覽器不支援嵌入式 PDF。請下載 PDF 查看：<a href='[url]' target='_blank'>下載 PDF</a></p>",
    },
  ],
  [
    ["de"],
    {
      hint: "<p>Dieser Browser unterstützt das Einbetten von PDFs nicht. Laden Sie die PDF herunter, um sie anzuzeigen: <a href='[url]' target='_blank'>PDF herunterladen</a></p>",
    },
  ],
  [
    ["de"],
    {
      hint: "<p>Dieser Browser unterstützt das Einbetten von PDFs nicht. Laden Sie die PDF herunter, um sie anzuzeigen: <a href='[url]' target='_blank'>PDF herunterladen</a></p>",
    },
  ],
  [
    ["vi"],
    {
      hint: "<p>Trình duyệt này không hỗ trợ nhúng tệp PDF. Vui lòng tải xuống tệp PDF để xem: <a href='[url]' target='_blank'>Tải xuống PDF</a></p>",
    },
  ],
  [
    ["uk"],
    {
      hint: "<p>Цей браузер не підтримує вбудовування PDF. Будь ласка, завантажте PDF, щоб переглянути його: <a href='[url]' target='_blank'>Завантажити PDF</a></p>",
    },
  ],
  [
    ["ru"],
    {
      hint: "<p>Этот браузер не поддерживает встроенные PDF. Пожалуйста, загрузите PDF, чтобы просмотреть его: <a href='[url]' target='_blank'>Загрузить PDF</a></p>",
    },
  ],
  [
    ["br"],
    {
      hint: "<p>Este navegador não suporta incorporação de PDF. Faça o download do PDF para visualizá-lo: <a href='[url]' target='_blank'>Baixar PDF</a></p>",
    },
  ],
  [
    ["pl"],
    {
      hint: "<p>Ten przeglądarka nie obsługuje osadzania plików PDF. Pobierz plik PDF, aby go wyświetlić: <a href='[url]' target='_blank'>Pobierz PDF</a></p>",
    },
  ],
  [
    ["sk"],
    {
      hint: "<p>Tento prehliadač nepodporuje vkladanie PDF. Stiahnite si PDF, aby ste ho mohli zobraziť: <a href='[url]' target='_blank'>Stiahnuť PDF</a></p>",
    },
  ],
  [
    ["fr"],
    {
      hint: "<p>Ce navigateur ne prend pas en charge l'intégration de fichiers PDF. Téléchargez le PDF pour le visualiser: <a href='[url]' target='_blank'>Télécharger le PDF</a></p>",
    },
  ],
  [
    ["es"],
    {
      hint: "<p>Este navegador no admite la incorporación de archivos PDF. Descargue el PDF para verlo: <a href='[url]' target='_blank'>Descargar PDF</a></p>",
    },
  ],
  [
    ["ja"],
    {
      hint: "<p>このブラウザは PDF の埋め込みをサポートしていません。 PDF をダウンロードして表示してください: <a href='[url]' target='_blank'>PDF をダウンロード</a></p>",
    },
  ],
  [
    ["tr"],
    {
      hint: "<p>Bu tarayıcı PDF'leri gömme özelliğini desteklemiyor. Lütfen PDF'i görüntülemek için indirin: <a href='[url]' target='_blank'>PDF'i İndir</a></p>",
    },
  ],
  [
    ["ko"],
    {
      hint: "<p>이 브라우저는 PDF를 포함할 수 없습니다. PDF를 보려면 다운로드하십시오: <a href='[url]' target='_blank'>PDF 다운로드</a></p>",
    },
  ],
  [
    ["fi"],
    {
      hint: "<p>Tämä selain ei tue PDF-tiedostojen upottamista. Lataa PDF-tiedosto nähdäksesi sen: <a href='[url]' target='_blank'>Lataa PDF</a></p>",
    },
  ],
  [
    ["hu"],
    {
      hint: "<p>Ez a böngésző nem támogatja a PDF beágyazását. Kérlek töltsd le a PDF-et megtekintéshez: <a href='[url]' target='_blank'>PDF letöltése</a></p>",
    },
  ],
  [
    ["id"],
    {
      hint: "<p>Browser ini tidak mendukung penyematan PDF. Silakan unduh PDF untuk melihatnya: <a href='[url]' target='_blank'>Unduh PDF</a></p>",
    },
  ],
  [
    ["nl"],
    {
      hint: "<p>Deze browser ondersteunt geen embedded PDFs. Gelieve de PDF te downloaden om ze te bekjken: <a href='[url]' target='_blank'>Download PDF</a></p>",
    },
  ],
];
